import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { PaginatedResponse, Announcement } from "@shared/models";
import { Observable } from "rxjs";
import { ToHttpHeadersService } from "../utils";
import { MESSAGES } from "@shared/constants";
import { ToastType } from "@shared/enums";

@Injectable({
	providedIn: 'root'
})
export class AnnouncementService {
	url = `/api/v1/admin/announcement`;
	http = inject(HttpClient);
	toHttpHeaders = inject(ToHttpHeadersService);

	list(params?: any): Observable<PaginatedResponse<Announcement>> {
		return this.http.get<PaginatedResponse<Announcement>>(`${this.url}`, { params });
	}

    post(data: Announcement): Observable<Announcement> {
        return this.http.post<Announcement>(
            `${this.url}`,
            data,
            this.toHttpHeaders.transform(
                ToastType.SUCCESS,
                MESSAGES.SUCCESS_CREATE.replace('{$1}', 'Announcement')
            )
        );
    }

    put(data: Announcement): Observable<Announcement> {
        return this.http.put<Announcement>(
            `${this.url}`,
            data,
            this.toHttpHeaders.transform(
                ToastType.SUCCESS,
                MESSAGES.SUCCESS_UPDATE.replace('{$1}', 'Announcement')
            )
        );
    }

    delete(id: number): Observable<any> {
        return this.http.delete(
            `${this.url}/${id}`,
            this.toHttpHeaders.transform(
                ToastType.SUCCESS,
                MESSAGES.SUCCESS_DELETE.replace('{$1}', 'Announcement')
            )
        );
    }

}